import { Button } from '@atlas/components';
import classNames from 'classnames';
import type { FC } from 'react';

import Icon from 'components/Icon/Icon';
import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';
import useCookiePopup from './useCookiePopup';

import styles from './CookiePopup.module.scss';

const CookiePopup: FC = () => {
  const layout = useLayout();
  const { closeCookiePopup } = useCookiePopup();

  return (
    <div className={classNames(styles.cookie, styles[layout])}>
      <Icon
        name="cookie"
        width={70}
        height={70}
        className={styles['cookie-image']}
      />
      <div className={styles['cookie-title']}>
        <Translation message="cookies" />
      </div>
      <p className={styles['cookie-description']}>
        <Translation message="cookies_description" />
      </p>
      <Button onClick={closeCookiePopup}>
        <Translation message="cookies_ok_understood" />
      </Button>
    </div>
  );
};

export default CookiePopup;
